export interface IconProps {
  /**
   * Optional, fill color
   */
  fill?: string;
  /**
   * Optional, size of the svg icon
   */
  size?: number;
  /**
   * Optional, on click event.
   */
  onClick?: (e: React.MouseEvent<SVGElement>) => void;
}

export function EmailOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-email-outline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M3.2 28.8c-0.88 0-1.632-0.314-2.261-0.941-0.58-0.561-0.94-1.346-0.94-2.215 0-0.015 0-0.031 0-0.046l-0 0.002v-19.2c0-0.88 0.314-1.632 0.941-2.261 0.561-0.58 1.346-0.939 2.215-0.939 0.015 0 0.031 0 0.046 0l-0.002-0h25.6c0.88 0 1.632 0.314 2.261 0.941 0.624 0.626 0.939 1.379 0.939 2.259v19.2c0 0.88-0.314 1.632-0.939 2.259-0.561 0.581-1.347 0.941-2.217 0.941-0.015 0-0.031-0-0.046-0l0.002 0h-25.6zM16 17.6l-12.8-8v16h25.6v-16l-12.8 8zM16 14.4l12.8-8h-25.6l12.8 8zM3.2 9.6v0z"
      />
    </svg>
  );
}

export function PhoneOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-phone-outline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M30.133 32c-3.703 0-7.364-0.807-10.977-2.423-3.614-1.614-6.903-3.902-9.866-6.866s-5.252-6.252-6.866-9.866c-1.618-3.614-2.423-7.275-2.423-10.977 0-0.533 0.178-0.978 0.533-1.333s0.8-0.533 1.333-0.533h7.2c0.003 0 0.005-0 0.008-0 0.424 0 0.811 0.16 1.104 0.423l-0.002-0.001c0.301 0.247 0.511 0.595 0.576 0.991l0.001 0.009 1.156 6.222c0.059 0.475 0.044 0.875-0.044 1.2s-0.252 0.608-0.489 0.844l-4.311 4.356c0.592 1.097 1.298 2.156 2.11 3.177 0.816 1.022 1.712 2.009 2.69 2.956 0.919 0.919 1.881 1.771 2.889 2.556 1.008 0.784 2.075 1.502 3.2 2.155l4.178-4.178c0.285-0.275 0.636-0.482 1.028-0.596l0.018-0.004c0.261-0.087 0.562-0.137 0.875-0.137 0.138 0 0.273 0.010 0.406 0.029l-0.015-0.002 6.133 1.244c0.414 0.119 0.756 0.334 1.022 0.645 0.248 0.275 0.4 0.642 0.4 1.044v7.2c0 0.533-0.178 0.978-0.533 1.333s-0.8 0.533-1.333 0.533zM5.378 10.667l2.933-2.933-0.756-4.178h-3.956c0.148 1.214 0.356 2.414 0.622 3.6s0.652 2.356 1.156 3.511zM21.289 26.578c1.156 0.503 2.334 0.903 3.534 1.2s2.407 0.489 3.621 0.578v-3.911l-4.178-0.844-2.978 2.978z"
      />
    </svg>
  );
}

export function DeleteTrashOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-delete-trash-icon"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M7.113 32c-0.98 0-1.816-0.348-2.512-1.044-0.644-0.623-1.044-1.496-1.044-2.462 0-0.018 0-0.035 0-0.053v0.003-23.11h-1.78v-3.556h8.89v-1.778h10.668v1.778h8.888v3.556h-1.778v23.11c0 0.98-0.348 1.816-1.044 2.512-0.623 0.644-1.496 1.044-2.462 1.044-0.017 0-0.034-0-0.051-0h-17.777zM24.891 5.334h-17.78v23.11h17.78v-23.11zM10.667 24.888h3.556v-16h-3.556v16zM17.779 24.888h3.556v-16h-3.556v16z"
      />
    </svg>
  );
}

export function EditPencilOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-edit-pencil-icon"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M2.634 29.367h2.252l19.921-19.923-2.25-2.25-19.923 19.921v2.252zM0.001 32v-5.995l25.195-25.235c0.273-0.275 0.567-0.474 0.881-0.593 0.298-0.112 0.643-0.176 1.003-0.176 0.347 0 0.68 0.060 0.99 0.171l-0.021-0.006c0.314 0.111 0.616 0.308 0.911 0.587l2.268 2.252c0.282 0.294 0.48 0.597 0.595 0.911 0.111 0.291 0.175 0.627 0.175 0.979 0 0.362-0.068 0.707-0.192 1.025l0.007-0.019c-0.122 0.324-0.316 0.618-0.585 0.885l-25.233 25.215h-5.995zM23.662 8.34l-1.106-1.146 2.25 2.252-1.144-1.106z"
      />
    </svg>
  );
}

export function PersonRemoveOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-person-remove-icon"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M22.857 14.476v-3.048h9.143v3.048h-9.143zM12.19 16c-1.676 0-3.112-0.597-4.305-1.79s-1.79-2.629-1.79-4.305 0.597-3.112 1.79-4.305c1.193-1.193 2.629-1.79 4.305-1.79s3.112 0.597 4.305 1.79c1.193 1.193 1.79 2.629 1.79 4.305s-0.597 3.112-1.79 4.305c-1.193 1.193-2.629 1.79-4.305 1.79zM0 28.19v-4.267c0-0.864 0.222-1.656 0.667-2.382 0.443-0.724 1.035-1.275 1.771-1.656 1.373-0.711 2.972-1.318 4.644-1.739l0.156-0.033c1.483-0.375 3.185-0.59 4.938-0.59 0.005 0 0.010 0 0.015 0h-0.001c1.676 0 3.326 0.198 4.952 0.59 1.626 0.395 3.226 0.984 4.8 1.772 0.736 0.381 1.326 0.933 1.771 1.656 0.445 0.725 0.667 1.518 0.667 2.382v4.267h-24.381zM3.048 25.143h18.286v-1.219c-0-0.554-0.304-1.037-0.755-1.291l-0.007-0.004c-1.371-0.686-2.755-1.199-4.152-1.542-1.27-0.326-2.727-0.513-4.229-0.513s-2.959 0.187-4.351 0.539l0.122-0.026c-1.397 0.343-2.781 0.856-4.152 1.542-0.458 0.258-0.762 0.741-0.762 1.295v1.219zM12.19 12.952c0.838 0 1.554-0.299 2.152-0.896 0.597-0.596 0.896-1.314 0.896-2.152s-0.299-1.554-0.896-2.152c-0.534-0.553-1.283-0.896-2.111-0.896-0.014 0-0.028 0-0.042 0l0.002-0c-0.838 0-1.554 0.299-2.152 0.896-0.553 0.534-0.896 1.283-0.896 2.111 0 0.014 0 0.028 0 0.042l-0-0.002c0 0.838 0.299 1.554 0.896 2.152 0.596 0.597 1.314 0.896 2.152 0.896z"
      />
    </svg>
  );
}

export function Lightning({ fill = '#656565', size = 20, onClick }: IconProps) {
  const aspectRatio = 1.5;
  const height = Math.round(size * aspectRatio);
  let strokeWidth = 1.25;
  if (size <= 16) {
    strokeWidth = 1;
  } else if (size <= 20) {
    strokeWidth = 1.5;
  }

  return (
    <svg
      id="icon-lightning"
      width={size}
      height={height}
      viewBox="0 0 14 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      onClick={onClick}
      style={{ transition: 'fill 0.2s, stroke 0.2s' }}
    >
      <path
        d="M1.71311 13.6667C3.28262 10.8958 5.50893 6.9923 8.39317 1.9365L7.35668 9.19191L7.19362 10.3333H8.34663H12.3385C9.88145 14.6196 8.02587 17.8606 6.77032 20.0551C6.30401 20.8701 5.92046 21.5407 5.6196 22.0669L6.65658 14.8081L6.81964 13.6667H5.66663H1.71311ZM0.910386 13.6609C0.910562 13.6608 0.914123 13.6612 0.920549 13.6628C0.913422 13.6618 0.91021 13.6611 0.910386 13.6609Z"
        fill={fill}
        stroke={fill}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

export function ArrowBack({ fill = '#414042', size = 24, onClick }: IconProps) {
  return (
    <svg
      id="icon-arrow-back"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
        d="M14.0002 18L15.4102 16.59L10.8302 12L15.4102 7.41L14.0002 6L8.00016 12L14.0002 18Z"
      />
    </svg>
  );
}

export function TacticIcon({
  fill = '#656565',
  size = 18,
  onClick,
}: IconProps) {
  const height = Math.round((size * 20) / 18);

  return (
    <svg
      id="icon-tactic"
      width={size}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M13.4 19.635L12 18.235L13.575 16.635L12 15.06L13.4 13.635L15 15.235L16.575 13.635L18 15.06L16.4 16.635L18 18.235L16.575 19.635L15 18.06L13.4 19.635ZM3 17.635C3.28333 17.635 3.52083 17.5392 3.7125 17.3475C3.90417 17.1558 4 16.9183 4 16.635C4 16.3517 3.90417 16.1142 3.7125 15.9225C3.52083 15.7308 3.28333 15.635 3 15.635C2.71667 15.635 2.47917 15.7308 2.2875 15.9225C2.09583 16.1142 2 16.3517 2 16.635C2 16.9183 2.09583 17.1558 2.2875 17.3475C2.47917 17.5392 2.71667 17.635 3 17.635ZM3 19.635C2.16667 19.635 1.45833 19.3433 0.875 18.76C0.291667 18.1767 0 17.4683 0 16.635C0 15.8017 0.291667 15.0933 0.875 14.51C1.45833 13.9267 2.16667 13.635 3 13.635C3.61667 13.635 4.17917 13.8058 4.6875 14.1475C5.19583 14.4892 5.56667 14.9517 5.8 15.535C6.45 15.3517 6.97917 14.9933 7.3875 14.46C7.79583 13.9267 8 13.3183 8 12.635V8.63501C8 7.25168 8.4875 6.07251 9.4625 5.09751C10.4375 4.12251 11.6167 3.63501 13 3.63501H14.15L12.575 2.06001L14 0.63501L18 4.63501L14 8.63501L12.575 7.23501L14.15 5.63501H13C12.1667 5.63501 11.4583 5.92668 10.875 6.51001C10.2917 7.09334 10 7.80168 10 8.63501V12.635C10 13.8517 9.60833 14.9225 8.825 15.8475C8.04167 16.7725 7.05 17.3433 5.85 17.56C5.65 18.1767 5.2875 18.6767 4.7625 19.06C4.2375 19.4433 3.65 19.635 3 19.635ZM1.4 7.63501L0 6.23501L1.575 4.63501L0 3.06001L1.4 1.63501L3 3.23501L4.575 1.63501L6 3.06001L4.4 4.63501L6 6.23501L4.575 7.63501L3 6.06001L1.4 7.63501Z"
        fill={fill}
      />
    </svg>
  );
}

export function ChevronRight({
  fill = '#656565',
  size = 24,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-chevron-right"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
        d="M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L16.0001 12L9.99984 6Z"
      />
    </svg>
  );
}

export function ChevronDown({
  fill = '#656565',
  size = 24,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-chevron-down"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ transform: 'rotate(90deg)' }}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
        d="M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L16.0001 12L9.99984 6Z"
      />
    </svg>
  );
}

export function ReportingOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-reporting-outline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M3.516 28.462v0.022l24.968-0.022v-24.946l-24.968 0.022v24.924zM10.637 16.022v8.857h-3.516v-8.857h3.516zM24.879 7.121v17.758h-3.516v-17.758h3.516zM17.758 19.583v5.296h-3.516v-5.296h3.516zM17.758 12.462v3.516h-3.516v-3.516h3.516zM3.538 32c-0.973 0-1.806-0.346-2.499-1.039s-1.039-1.526-1.039-2.499v-24.924c0-0.973 0.346-1.806 1.039-2.499s1.526-1.039 2.499-1.039h24.924c0.973 0 1.806 0.346 2.499 1.039s1.039 1.526 1.039 2.499v24.924c0 0.973-0.346 1.806-1.039 2.499s-1.526 1.039-2.499 1.039h-24.924z"
      />
    </svg>
  );
}

export function NotebookOutline({
  fill = '#656565',
  size = 24,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-notebook-outline"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M5.39998 18.5996H18.6V9.74961L14.25 5.39961H5.39998V18.5996ZM5.39998 20.3996C4.90498 20.3996 4.48123 20.2234 4.12873 19.8709C3.77623 19.5184 3.59998 19.0946 3.59998 18.5996V5.39961C3.59998 4.90461 3.77623 4.48086 4.12873 4.12836C4.48123 3.77586 4.90498 3.59961 5.39998 3.59961H15L20.4 8.99961V18.5996C20.4 19.0946 20.2237 19.5184 19.8712 19.8709C19.5187 20.2234 19.095 20.3996 18.6 20.3996H5.39998ZM7.19998 16.7996H16.8V14.9996H7.19998V16.7996ZM7.19998 13.1996H16.8V11.3996H7.19998V13.1996ZM7.19998 9.59961H14.4V7.79961H7.19998V9.59961Z"
        fill={fill}
      />
    </svg>
  );
}

export function RefreshOutline({
  fill = '#656565',
  size = 24,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-refresh-outline"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9983 8L14.9983 12H17.9983C17.9983 15.31 15.3083 18 11.9983 18C10.9883 18 10.0283 17.75 9.19828 17.3L7.73828 18.76C8.96828 19.54 10.4283 20 11.9983 20C16.4183 20 19.9983 16.42 19.9983 12H22.9983L18.9983 8ZM6 12C6 8.69 8.69 6 12 6C13.01 6 13.97 6.25 14.8 6.7L16.26 5.24C15.03 4.46 13.57 4 12 4C7.58 4 4 7.58 4 12H1L5 16L9 12H6Z"
        fill={fill}
      />
    </svg>
  );
}

export function PreparedReports({ size = 20 }: { size: number }) {
  return (
    <svg
      id="icon-prepared_reports"
      width={size}
      height={size}
      viewBox="0 0 32 32"
    >
      <path
        fill="#d9e7ff"
        d="M30.586 7.946c-0.817 1.361-2.34 2.231-4.027 2.231-2.395 0-4.408-1.796-4.735-4.082h-18.884c-1.252 0-2.231 0.98-2.231 2.231v15.456h29.932v-15.401c0-0.163-0.054-0.272-0.054-0.435z"
      />
      <path
        fill="#fff"
        d="M21.443 29.279c0.544 0 1.034 0.435 1.034 1.034 0 0.272-0.109 0.544-0.272 0.707s-0.435 0.272-0.708 0.272h-11.591c-0.545 0-1.034-0.436-1.034-1.034 0-0.272 0.109-0.544 0.273-0.707s0.435-0.327 0.707-0.327h11.592v0.054h0zM30.641 23.837v1.142c0 1.252-0.98 2.231-2.231 2.231h-25.469c-1.252 0-2.231-0.98-2.231-2.231v-1.142h29.931zM16.001 1.36c0 0 0 0 0 0 0.571 0 1.033 0.463 1.033 1.033 0 0 0 0.001 0 0.001v-0c0 0.571-0.463 1.034-1.034 1.034s-1.034-0.463-1.034-1.034v0c0-0 0-0 0-0 0-0.571 0.463-1.034 1.034-1.034v0zM4.79 3.428c0.752 0 1.361 0.609 1.361 1.361s-0.609 1.361-1.361 1.361v0c-0.752 0-1.361-0.609-1.361-1.361s0.609-1.361 1.361-1.361v0zM11.593 9.524v8.163c-0.163-1.905-1.796-3.429-3.701-3.429 0.004 0 0.009 0 0.014 0 0.744 0 1.347-0.603 1.347-1.347 0-0.005-0-0.009-0-0.014v0.001c0-0.004 0-0.009 0-0.014 0-0.744-0.603-1.347-1.347-1.347-0.005 0-0.009 0-0.014 0h0.001c-0.004-0-0.009-0-0.013-0-0.744 0-1.347 0.603-1.347 1.347 0 0.005 0 0.009 0 0.014v-0.001c-0 0.004-0 0.009-0 0.014 0 0.744 0.603 1.347 1.347 1.347 0.005 0 0.010-0 0.015-0h-0.001c-1.959 0-3.537 1.469-3.701 3.429v-8.164h7.401z"
      />
      <path
        fill="#fff"
        d="M7.837 14.313c1.959 0 3.538 1.469 3.701 3.429h-7.402c0.163-1.959 1.741-3.429 3.7-3.429z"
      />
      <path
        fill="#fff"
        d="M7.838 11.592c0.751 0 1.36 0.609 1.36 1.361s-0.609 1.361-1.361 1.361c-0 0-0 0-0 0v0c-0.751 0-1.361-0.609-1.361-1.361s0.609-1.361 1.361-1.361v0zM30.586 7.946c-0.817 1.36-2.34 2.231-4.027 2.231-2.395 0-4.409-1.796-4.735-4.082-0.054-0.217-0.054-0.435-0.054-0.707 0-2.612 2.123-4.789 4.789-4.789s4.789 2.123 4.789 4.789c-0.054 0.98-0.326 1.85-0.761 2.558z"
      />
      <path
        fill="#937df0"
        d="M26.341 29.442c0.109 0.109 0.217 0.272 0.217 0.49 0 0.163-0.054 0.381-0.217 0.49s-0.272 0.218-0.489 0.218c-0.381 0-0.708-0.327-0.708-0.708 0-0.163 0.055-0.381 0.217-0.49 0.109-0.109 0.272-0.217 0.49-0.217s0.381 0.109 0.49 0.217zM10.722 2.231c0.109 0.109 0.217 0.272 0.217 0.49 0 0.163-0.054 0.381-0.217 0.49s-0.272 0.217-0.49 0.217c-0.381 0-0.708-0.327-0.708-0.707 0-0.163 0.055-0.381 0.218-0.49 0.109-0.109 0.272-0.218 0.49-0.218s0.327 0.11 0.49 0.218zM4.572 29.442c0.109 0.109 0.218 0.272 0.218 0.49s-0.055 0.381-0.218 0.49c-0.163 0.109-0.272 0.218-0.489 0.218-0.381 0-0.708-0.327-0.708-0.708 0-0.163 0.055-0.381 0.218-0.49s0.272-0.217 0.49-0.217c0.217 0 0.38 0.109 0.489 0.217zM30.641 24.489h-29.932c-0.381 0-0.708-0.327-0.708-0.708s0.327-0.708 0.708-0.708h29.932c0.381 0 0.707 0.327 0.707 0.708-0.054 0.436-0.327 0.708-0.707 0.708zM21.443 32h-11.538c-0.925 0-1.687-0.762-1.687-1.687 0-0.435 0.163-0.871 0.489-1.198 0.305-0.302 0.725-0.489 1.188-0.489 0.003 0 0.006 0 0.009 0h2.394c0.381 0 0.707 0.326 0.707 0.707s-0.326 0.707-0.707 0.707h-2.395c-0.109 0-0.163 0.054-0.218 0.109s-0.109 0.109-0.109 0.218c0 0.163 0.163 0.327 0.327 0.327h11.538c0.109 0 0.163-0.054 0.217-0.109s0.109-0.163 0.109-0.217c0-0.163-0.164-0.327-0.326-0.327h-2.395c-0.381 0-0.708-0.326-0.708-0.707s0.326-0.707 0.708-0.707h2.395c0.925 0 1.687 0.762 1.687 1.687 0 0.435-0.163 0.87-0.489 1.197-0.327 0.272-0.762 0.49-1.197 0.49z"
      />
      <path
        fill="#937df0"
        d="M19.048 29.932h-6.803c-0.381 0-0.707-0.327-0.707-0.707v-2.068c0-0.381 0.326-0.708 0.707-0.708s0.708 0.327 0.708 0.708v1.361h5.442v-1.361c0-0.381 0.327-0.708 0.708-0.708s0.708 0.327 0.708 0.708v2.068c-0.055 0.435-0.382 0.707-0.763 0.707zM11.593 18.394h-7.51c-0.381 0-0.708-0.327-0.708-0.707v-8.163c0-0.381 0.327-0.708 0.708-0.708h7.51c0.381 0 0.708 0.327 0.708 0.708v8.163c-0.055 0.381-0.327 0.707-0.708 0.707zM4.79 17.034h6.15v-6.803h-6.15v6.803zM20.409 11.592h-6.095c-0.381 0-0.707-0.327-0.707-0.708s0.326-0.707 0.707-0.707h6.15c0.381 0 0.707 0.327 0.707 0.707-0.054 0.382-0.381 0.708-0.762 0.708zM22.477 13.605h-8.163c-0.381 0-0.707-0.327-0.707-0.707s0.326-0.708 0.707-0.708h8.163c0.381 0 0.708 0.326 0.708 0.708-0.055 0.436-0.327 0.707-0.708 0.707z"
      />
      <path
        fill="#937df0"
        d="M28.409 27.918h-25.469c-0.004 0-0.008 0-0.012 0-1.616 0-2.927-1.31-2.927-2.927 0-0.004 0-0.009 0-0.013v0.001-16.598c0-0.004-0-0.008-0-0.012 0-1.616 1.31-2.926 2.926-2.926 0.004 0 0.009 0 0.013 0h18.884c0.381 0 0.708 0.326 0.708 0.707s-0.327 0.708-0.708 0.708h-18.884c-0.871 0.001-1.577 0.707-1.578 1.578v16.598c0.001 0.871 0.707 1.577 1.578 1.578h25.47c0.871-0.001 1.578-0.707 1.578-1.578v-17.035c0-0.381 0.327-0.708 0.707-0.708 0.327 0 0.599 0.272 0.653 0.598 0.055 0.163 0.055 0.327 0.055 0.49v16.598c-0.109 1.633-1.415 2.94-2.993 2.94z"
      />
      <path
        fill="#937df0"
        d="M26.558 10.884c-1.306 0-2.612-0.49-3.592-1.36s-1.633-2.014-1.796-3.32c-0.054-0.272-0.054-0.49-0.054-0.762 0-2.993 2.449-5.442 5.442-5.442s5.442 2.449 5.442 5.443c0 1.034-0.272 2.013-0.816 2.884-1.033 1.632-2.721 2.558-4.625 2.558zM26.558 1.361c-2.231 0-4.081 1.851-4.081 4.082 0 0.217 0 0.381 0.054 0.598 0.272 2.013 2.014 3.483 4.027 3.483 1.415 0 2.721-0.708 3.483-1.905 0.381-0.653 0.599-1.415 0.599-2.177 0-2.23-1.851-4.081-4.083-4.081z"
      />
      <path
        fill="#937df0"
        d="M25.905 8.163c-0.163 0-0.327-0.054-0.489-0.217l-1.469-1.469c-0.126-0.125-0.204-0.298-0.204-0.49s0.078-0.365 0.204-0.49l0-0c0.125-0.126 0.298-0.204 0.49-0.204s0.365 0.078 0.49 0.204l0.98 0.98 2.884-2.884c0.125-0.126 0.298-0.204 0.49-0.204s0.365 0.078 0.49 0.204l0 0c0.126 0.125 0.204 0.298 0.204 0.49s-0.078 0.365-0.204 0.49l-3.374 3.374c-0.163 0.163-0.327 0.217-0.49 0.217zM16.001 4.081c-0.925 0-1.687-0.762-1.687-1.687s0.762-1.687 1.687-1.687c0.925 0 1.687 0.762 1.687 1.687s-0.762 1.687-1.687 1.687zM16.001 2.068c-0.164 0-0.327 0.163-0.327 0.327s0.163 0.327 0.327 0.327c0.163 0 0.327-0.163 0.327-0.327s-0.164-0.327-0.327-0.327zM4.79 6.803c-0 0-0.001 0-0.001 0-1.142 0-2.067-0.925-2.067-2.067 0-0 0-0.001 0-0.001v0c0-0 0-0 0-0 0-1.142 0.926-2.067 2.067-2.067 0 0 0.001 0 0.001 0h-0c0 0 0.001 0 0.001 0 1.142 0 2.067 0.925 2.067 2.067 0 0 0 0.001 0 0.001v-0c0 1.143-0.979 2.068-2.068 2.068zM4.79 4.082c-0.381 0-0.707 0.327-0.707 0.708s0.327 0.707 0.707 0.707c0.381 0 0.708-0.327 0.708-0.707-0.054-0.381-0.326-0.708-0.708-0.708z"
      />
    </svg>
  );
}

export function ActionPlan({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-action-plan"
      width={size}
      height={size}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M2 8.5C1.45 8.5 0.979167 8.30417 0.5875 7.9125C0.195833 7.52083 0 7.05 0 6.5V2.5C0 1.95 0.195833 1.47917 0.5875 1.0875C0.979167 0.695833 1.45 0.5 2 0.5H16C16.55 0.5 17.0208 0.695833 17.4125 1.0875C17.8042 1.47917 18 1.95 18 2.5V6.5C18 7.05 17.8042 7.52083 17.4125 7.9125C17.0208 8.30417 16.55 8.5 16 8.5H2ZM2 6.5H16V2.5H2V6.5ZM2 18.5C1.45 18.5 0.979167 18.3042 0.5875 17.9125C0.195833 17.5208 0 17.05 0 16.5V12.5C0 11.95 0.195833 11.4792 0.5875 11.0875C0.979167 10.6958 1.45 10.5 2 10.5H16C16.55 10.5 17.0208 10.6958 17.4125 11.0875C17.8042 11.4792 18 11.95 18 12.5V16.5C18 17.05 17.8042 17.5208 17.4125 17.9125C17.0208 18.3042 16.55 18.5 16 18.5H2ZM2 16.5H16V12.5H2V16.5Z"
        fill={fill}
      />
    </svg>
  );
}

export function AddCalendarOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-add-calendar"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M23.2 32v-4.8h-4.8v-3.2h4.8v-4.8h3.2v4.8h4.8v3.2h-4.8v4.8h-3.2zM4 28.8c-0.88 0-1.633-0.313-2.26-0.94s-0.94-1.38-0.94-2.26v-19.2c0-0.88 0.313-1.633 0.94-2.26s1.38-0.94 2.26-0.94h1.6v-3.2h3.2v3.2h9.6v-3.2h3.2v3.2h1.6c0.88 0 1.633 0.313 2.26 0.94s0.94 1.38 0.94 2.26v9.76c-0.533-0.080-1.067-0.12-1.6-0.12s-1.067 0.040-1.6 0.12v-3.36h-19.2v12.8h11.2c0 0.533 0.040 1.067 0.12 1.6s0.227 1.067 0.44 1.6h-11.76zM4 9.6h19.2v-3.2h-19.2v3.2z"
      />
    </svg>
  );
}

export function AddPersonOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-AddPersonOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M24.727 18.909v-4.364h-4.364v-2.909h4.364v-4.364h2.909v4.364h4.364v2.909h-4.364v4.364h-2.909zM11.636 16c-1.6 0-2.97-0.57-4.109-1.709s-1.709-2.509-1.709-4.109c0-1.6 0.57-2.97 1.709-4.109s2.509-1.709 4.109-1.709c1.6 0 2.97 0.57 4.109 1.709s1.709 2.509 1.709 4.109c0 1.6-0.57 2.97-1.709 4.109s-2.509 1.709-4.109 1.709zM0 27.636v-4.073c0-0.824 0.212-1.582 0.636-2.273s0.988-1.218 1.691-1.582c1.503-0.752 3.030-1.315 4.582-1.691s3.127-0.564 4.727-0.564 3.176 0.188 4.727 0.564c1.552 0.376 3.079 0.939 4.582 1.691 0.703 0.364 1.267 0.891 1.691 1.582s0.636 1.448 0.636 2.273v4.073h-23.273zM2.909 24.727h17.455v-1.164c0-0.267-0.067-0.509-0.2-0.727s-0.309-0.388-0.527-0.509c-1.309-0.655-2.63-1.145-3.964-1.473s-2.679-0.491-4.036-0.491-2.703 0.164-4.036 0.491c-1.333 0.327-2.655 0.818-3.964 1.473-0.218 0.121-0.394 0.291-0.527 0.509s-0.2 0.461-0.2 0.727v1.164zM11.636 13.091c0.8 0 1.485-0.285 2.055-0.855s0.855-1.255 0.855-2.055c0-0.8-0.285-1.485-0.855-2.055s-1.255-0.855-2.055-0.855c-0.8 0-1.485 0.285-2.055 0.855s-0.855 1.255-0.855 2.055c0 0.8 0.285 1.485 0.855 2.055s1.255 0.855 2.055 0.855z"
      />
    </svg>
  );
}

export function SearchOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-SearchOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M22.87 20.126h-1.445l-0.512-0.494c1.793-2.086 2.872-4.794 2.872-7.739 0-6.568-5.324-11.892-11.892-11.892s-11.892 5.324-11.892 11.892c0 6.568 5.324 11.892 11.892 11.892 2.946 0 5.654-1.079 7.739-2.872l0.494 0.512v1.445l9.148 9.13 2.726-2.726-9.13-9.148zM11.893 20.126c-4.556 0-8.233-3.678-8.233-8.233s3.678-8.233 8.233-8.233c4.556 0 8.233 3.678 8.233 8.233s-3.678 8.233-8.233 8.233z"
      />
    </svg>
  );
}

export function LocationOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-LocationOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M16 16c0.88 0 1.633-0.313 2.26-0.94s0.94-1.38 0.94-2.26c0-0.88-0.313-1.633-0.94-2.26s-1.38-0.94-2.26-0.94c-0.88 0-1.633 0.313-2.26 0.94s-0.94 1.38-0.94 2.26c0 0.88 0.313 1.633 0.94 2.26s1.38 0.94 2.26 0.94zM16 27.76c3.253-2.987 5.667-5.7 7.24-8.14s2.36-4.607 2.36-6.5c0-2.907-0.927-5.287-2.78-7.14s-4.127-2.78-6.82-2.78c-2.693 0-4.967 0.927-6.82 2.78s-2.78 4.233-2.78 7.14c0 1.893 0.787 4.060 2.36 6.5s3.987 5.153 7.24 8.14zM16 32c-4.293-3.653-7.5-7.047-9.62-10.18s-3.18-6.033-3.18-8.7c0-4 1.287-7.187 3.86-9.56s5.553-3.56 8.94-3.56c3.387 0 6.367 1.187 8.94 3.56s3.86 5.56 3.86 9.56c0 2.667-1.060 5.567-3.18 8.7s-5.327 6.527-9.62 10.18z"
      />
    </svg>
  );
}

export function StarOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-StarOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M10.96 24.561l5.040-3.055 5.040 3.095-1.32-5.788 4.44-3.858-5.84-0.522-2.32-5.466-2.32 5.426-5.84 0.522 4.44 3.899-1.32 5.747zM6.12 31.273l2.6-11.294-8.72-7.596 11.52-1.005 4.48-10.651 4.48 10.651 11.52 1.005-8.72 7.596 2.6 11.294-9.88-5.989-9.88 5.989z"
      />
    </svg>
  );
}
export function PeopleGroupOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-PeopleGroupOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M0 27.2v-3.391c0-0.842 0.217-1.605 0.652-2.29s1.038-1.196 1.81-1.533c1.762-0.769 3.348-1.323 4.76-1.659s2.866-0.505 4.362-0.505c1.496 0 2.944 0.168 4.344 0.505s2.98 0.89 4.742 1.659c0.772 0.337 1.382 0.848 1.828 1.533s0.67 1.449 0.67 2.29v3.391h-23.167zM25.339 27.2v-3.391c0-1.515-0.386-2.759-1.158-3.733s-1.786-1.761-3.041-2.363c1.665 0.192 3.234 0.475 4.706 0.848s2.667 0.8 3.584 1.281c0.796 0.457 1.424 1.022 1.882 1.695s0.688 1.431 0.688 2.272v3.391h-6.661zM11.584 15.621c-1.593 0-2.896-0.505-3.909-1.515s-1.52-2.309-1.52-3.896 0.507-2.886 1.52-3.896c1.014-1.010 2.317-1.515 3.909-1.515s2.896 0.505 3.91 1.515c1.013 1.010 1.52 2.309 1.52 3.896s-0.507 2.886-1.52 3.896c-1.014 1.010-2.317 1.515-3.91 1.515zM24.615 10.211c0 1.587-0.507 2.886-1.52 3.896s-2.317 1.515-3.909 1.515c-0.266 0-0.561-0.018-0.887-0.054s-0.621-0.102-0.887-0.198c0.579-0.601 1.020-1.341 1.321-2.218s0.453-1.858 0.453-2.94-0.151-2.038-0.453-2.868c-0.302-0.83-0.742-1.593-1.321-2.29 0.265-0.072 0.561-0.132 0.887-0.18s0.621-0.072 0.887-0.072c1.593 0 2.896 0.505 3.909 1.515s1.52 2.309 1.52 3.896zM2.246 24.314h18.75v-0.505c0-0.385-0.115-0.757-0.344-1.118s-0.513-0.613-0.851-0.758c-1.738-0.769-3.198-1.286-4.38-1.551s-2.462-0.397-3.837-0.397c-1.376 0-2.661 0.132-3.855 0.397s-2.661 0.782-4.398 1.551c-0.338 0.144-0.615 0.397-0.833 0.758s-0.326 0.733-0.326 1.118l0.074 0.505zM11.584 13.457c0.941 0 1.72-0.307 2.335-0.92s0.923-1.389 0.923-2.327c0-0.938-0.308-1.713-0.923-2.327s-1.394-0.92-2.335-0.92c-0.941 0-1.719 0.307-2.335 0.92s-0.923 1.389-0.923 2.327c0 0.938 0.308 1.713 0.923 2.327s1.394 0.92 2.335 0.92z"
      />
    </svg>
  );
}

export function GlobeOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-GlobeOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M16 32c-2.187 0-4.253-0.42-6.2-1.26s-3.647-1.987-5.1-3.44c-1.453-1.453-2.6-3.153-3.44-5.1s-1.26-4.013-1.26-6.2c0-2.213 0.42-4.287 1.26-6.22s1.987-3.627 3.44-5.080c1.453-1.453 3.153-2.6 5.1-3.44s4.013-1.26 6.2-1.26c2.213 0 4.287 0.42 6.22 1.26s3.627 1.987 5.080 3.44c1.453 1.453 2.6 3.147 3.44 5.080s1.26 4.007 1.26 6.22c0 2.187-0.42 4.253-1.26 6.2s-1.987 3.647-3.44 5.1c-1.453 1.453-3.147 2.6-5.080 3.44s-4.007 1.26-6.22 1.26zM16 28.72c0.693-0.96 1.293-1.96 1.8-3s0.92-2.147 1.24-3.32h-6.080c0.32 1.173 0.733 2.28 1.24 3.32s1.107 2.040 1.8 3zM11.84 28.080c-0.48-0.88-0.9-1.793-1.26-2.74s-0.66-1.927-0.9-2.94h-4.72c0.773 1.333 1.74 2.493 2.9 3.48s2.487 1.72 3.98 2.2zM20.16 28.080c1.493-0.48 2.82-1.213 3.98-2.2s2.127-2.147 2.9-3.48h-4.72c-0.24 1.013-0.54 1.993-0.9 2.94s-0.78 1.86-1.26 2.74zM3.6 19.2h5.44c-0.080-0.533-0.14-1.060-0.18-1.58s-0.060-1.060-0.060-1.62c0-0.56 0.020-1.1 0.060-1.62s0.1-1.047 0.18-1.58h-5.44c-0.133 0.533-0.233 1.060-0.3 1.58s-0.1 1.060-0.1 1.62c0 0.56 0.033 1.1 0.1 1.62s0.167 1.047 0.3 1.58zM12.24 19.2h7.52c0.080-0.533 0.14-1.060 0.18-1.58s0.060-1.060 0.060-1.62c0-0.56-0.020-1.1-0.060-1.62s-0.1-1.047-0.18-1.58h-7.52c-0.080 0.533-0.14 1.060-0.18 1.58s-0.060 1.060-0.060 1.62c0 0.56 0.020 1.1 0.060 1.62s0.1 1.047 0.18 1.58zM22.96 19.2h5.44c0.133-0.533 0.233-1.060 0.3-1.58s0.1-1.060 0.1-1.62c0-0.56-0.033-1.1-0.1-1.62s-0.167-1.047-0.3-1.58h-5.44c0.080 0.533 0.14 1.060 0.18 1.58s0.060 1.060 0.060 1.62c0 0.56-0.020 1.1-0.060 1.62s-0.1 1.047-0.18 1.58zM22.32 9.6h4.72c-0.773-1.333-1.74-2.493-2.9-3.48s-2.487-1.72-3.98-2.2c0.48 0.88 0.9 1.793 1.26 2.74s0.66 1.927 0.9 2.94zM12.96 9.6h6.080c-0.32-1.173-0.733-2.28-1.24-3.32s-1.107-2.040-1.8-3c-0.693 0.96-1.293 1.96-1.8 3s-0.92 2.147-1.24 3.32zM4.96 9.6h4.72c0.24-1.013 0.54-1.993 0.9-2.94s0.78-1.86 1.26-2.74c-1.493 0.48-2.82 1.213-3.98 2.2s-2.127 2.147-2.9 3.48z"
      />
    </svg>
  );
}

export function TimeOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-GlobeOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M21.28 23.52l2.24-2.24-5.92-5.92v-7.36h-3.2v8.64l6.88 6.88zM16 32c-2.213 0-4.293-0.42-6.24-1.26s-3.64-1.98-5.080-3.42c-1.44-1.44-2.58-3.133-3.42-5.080s-1.26-4.027-1.26-6.24c0-2.213 0.42-4.293 1.26-6.24s1.98-3.64 3.42-5.080c1.44-1.44 3.133-2.58 5.080-3.42s4.027-1.26 6.24-1.26c2.213 0 4.293 0.42 6.24 1.26s3.64 1.98 5.080 3.42c1.44 1.44 2.58 3.133 3.42 5.080s1.26 4.027 1.26 6.24c0 2.213-0.42 4.293-1.26 6.24s-1.98 3.64-3.42 5.080c-1.44 1.44-3.133 2.58-5.080 3.42s-4.027 1.26-6.24 1.26zM16 28.8c3.547 0 6.567-1.247 9.060-3.74s3.74-5.513 3.74-9.060c0-3.547-1.247-6.567-3.74-9.060s-5.513-3.74-9.060-3.74c-3.547 0-6.567 1.247-9.060 3.74s-3.74 5.513-3.74 9.060c0 3.547 1.247 6.567 3.74 9.060s5.513 3.74 9.060 3.74z"
      />
    </svg>
  );
}
export function CapacityOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-CapacityOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M1.6 32v-0.92c0-0.64 0.173-1.227 0.52-1.76s0.827-0.933 1.44-1.2c0.693-0.293 1.407-0.52 2.14-0.68s1.5-0.24 2.3-0.24c0.8 0 1.567 0.080 2.3 0.24s1.447 0.387 2.14 0.68c0.613 0.267 1.093 0.667 1.44 1.2s0.52 1.12 0.52 1.76v0.92h-12.8zM17.6 32v-0.92c0-0.64 0.173-1.227 0.52-1.76s0.827-0.933 1.44-1.2c0.693-0.293 1.407-0.52 2.14-0.68s1.5-0.24 2.3-0.24c0.8 0 1.567 0.080 2.3 0.24s1.447 0.387 2.14 0.68c0.613 0.267 1.093 0.667 1.44 1.2s0.52 1.12 0.52 1.76v0.92h-12.8zM8 25.6c-0.88 0-1.633-0.313-2.26-0.94s-0.94-1.38-0.94-2.26c0-0.88 0.313-1.633 0.94-2.26s1.38-0.94 2.26-0.94c0.88 0 1.633 0.313 2.26 0.94s0.94 1.38 0.94 2.26c0 0.88-0.313 1.633-0.94 2.26s-1.38 0.94-2.26 0.94zM24 25.6c-0.88 0-1.633-0.313-2.26-0.94s-0.94-1.38-0.94-2.26c0-0.88 0.313-1.633 0.94-2.26s1.38-0.94 2.26-0.94c0.88 0 1.633 0.313 2.26 0.94s0.94 1.38 0.94 2.26c0 0.88-0.313 1.633-0.94 2.26s-1.38 0.94-2.26 0.94zM16 22.4l-4.8-4.8 1.68-1.68 1.92 1.88v-3.4h2.4v3.4l1.92-1.88 1.68 1.68-4.8 4.8zM0 12.8v-0.92c0-0.64 0.173-1.227 0.52-1.76s0.827-0.933 1.44-1.2c0.693-0.293 1.407-0.52 2.14-0.68s1.5-0.24 2.3-0.24c0.533 0 1.060 0.040 1.58 0.12s1.020 0.187 1.5 0.32c-0.453 0.453-0.813 0.973-1.080 1.56s-0.4 1.213-0.4 1.88v0.92h-8zM9.6 12.8v-0.92c0-0.64 0.173-1.227 0.52-1.76s0.827-0.933 1.44-1.2c0.693-0.293 1.407-0.52 2.14-0.68s1.5-0.24 2.3-0.24c0.8 0 1.567 0.080 2.3 0.24s1.447 0.387 2.14 0.68c0.613 0.267 1.093 0.667 1.44 1.2s0.52 1.12 0.52 1.76v0.92h-12.8zM24 12.8v-0.92c0-0.667-0.133-1.293-0.4-1.88s-0.627-1.107-1.080-1.56c0.48-0.133 0.98-0.24 1.5-0.32s1.047-0.12 1.58-0.12c0.8 0 1.567 0.080 2.3 0.24s1.447 0.387 2.14 0.68c0.613 0.267 1.093 0.667 1.44 1.2s0.52 1.12 0.52 1.76v0.92h-8zM6.4 6.4c-0.88 0-1.633-0.313-2.26-0.94s-0.94-1.38-0.94-2.26c0-0.88 0.313-1.633 0.94-2.26s1.38-0.94 2.26-0.94c0.88 0 1.633 0.313 2.26 0.94s0.94 1.38 0.94 2.26c0 0.88-0.313 1.633-0.94 2.26s-1.38 0.94-2.26 0.94zM16 6.4c-0.88 0-1.633-0.313-2.26-0.94s-0.94-1.38-0.94-2.26c0-0.88 0.313-1.633 0.94-2.26s1.38-0.94 2.26-0.94c0.88 0 1.633 0.313 2.26 0.94s0.94 1.38 0.94 2.26c0 0.88-0.313 1.633-0.94 2.26s-1.38 0.94-2.26 0.94zM25.6 6.4c-0.88 0-1.633-0.313-2.26-0.94s-0.94-1.38-0.94-2.26c0-0.88 0.313-1.633 0.94-2.26s1.38-0.94 2.26-0.94c0.88 0 1.633 0.313 2.26 0.94s0.94 1.38 0.94 2.26c0 0.88-0.313 1.633-0.94 2.26s-1.38 0.94-2.26 0.94z"
      />
    </svg>
  );
}

export function PersonOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-PersonOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M16 16c-2.2 0-4.083-0.783-5.65-2.35s-2.35-3.45-2.35-5.65c0-2.2 0.783-4.083 2.35-5.65s3.45-2.35 5.65-2.35c2.2 0 4.083 0.783 5.65 2.35s2.35 3.45 2.35 5.65c0 2.2-0.783 4.083-2.35 5.65s-3.45 2.35-5.65 2.35zM0 32v-5.6c0-1.133 0.292-2.175 0.875-3.125s1.358-1.675 2.325-2.175c2.067-1.033 4.167-1.808 6.3-2.325s4.3-0.775 6.5-0.775c2.2 0 4.367 0.258 6.5 0.775s4.233 1.292 6.3 2.325c0.967 0.5 1.742 1.225 2.325 2.175s0.875 1.992 0.875 3.125v5.6h-32zM4 28h24v-1.6c0-0.367-0.092-0.7-0.275-1s-0.425-0.533-0.725-0.7c-1.8-0.9-3.617-1.575-5.45-2.025s-3.683-0.675-5.55-0.675c-1.867 0-3.717 0.225-5.55 0.675s-3.65 1.125-5.45 2.025c-0.3 0.167-0.542 0.4-0.725 0.7s-0.275 0.633-0.275 1v1.6zM16 12c1.1 0 2.042-0.392 2.825-1.175s1.175-1.725 1.175-2.825c0-1.1-0.392-2.042-1.175-2.825s-1.725-1.175-2.825-1.175c-1.1 0-2.042 0.392-2.825 1.175s-1.175 1.725-1.175 2.825c0 1.1 0.392 2.042 1.175 2.825s1.725 1.175 2.825 1.175z"
      />
    </svg>
  );
}

export function CalendarOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-CalendarOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M20 25.6c-1.12 0-2.067-0.387-2.84-1.16s-1.16-1.72-1.16-2.84c0-1.12 0.387-2.067 1.16-2.84s1.72-1.16 2.84-1.16c1.12 0 2.067 0.387 2.84 1.16s1.16 1.72 1.16 2.84c0 1.12-0.387 2.067-1.16 2.84s-1.72 1.16-2.84 1.16zM4.8 32c-0.88 0-1.633-0.313-2.26-0.94s-0.94-1.38-0.94-2.26v-22.4c0-0.88 0.313-1.633 0.94-2.26s1.38-0.94 2.26-0.94h1.6v-3.2h3.2v3.2h12.8v-3.2h3.2v3.2h1.6c0.88 0 1.633 0.313 2.26 0.94s0.94 1.38 0.94 2.26v22.4c0 0.88-0.313 1.633-0.94 2.26s-1.38 0.94-2.26 0.94h-22.4zM4.8 28.8h22.4v-16h-22.4v16zM4.8 9.6h22.4v-3.2h-22.4v3.2z"
      />
    </svg>
  );
}

export function ChildOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-CalendarOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M20.444 15.556c-0.622 0-1.148-0.215-1.578-0.644s-0.644-0.956-0.644-1.578c0-0.622 0.215-1.148 0.644-1.578s0.956-0.644 1.578-0.644c0.622 0 1.148 0.215 1.578 0.644s0.644 0.956 0.644 1.578c0 0.622-0.215 1.148-0.644 1.578s-0.956 0.644-1.578 0.644zM11.556 15.556c-0.622 0-1.148-0.215-1.578-0.644s-0.644-0.956-0.644-1.578c0-0.622 0.215-1.148 0.644-1.578s0.956-0.644 1.578-0.644c0.622 0 1.148 0.215 1.578 0.644s0.644 0.956 0.644 1.578c0 0.622-0.215 1.148-0.644 1.578s-0.956 0.644-1.578 0.644zM16 24.889c-1.778 0-3.385-0.489-4.822-1.467s-2.496-2.267-3.178-3.867h16c-0.681 1.6-1.741 2.889-3.178 3.867s-3.044 1.467-4.822 1.467zM16 32c-2.222 0-4.304-0.422-6.244-1.267s-3.63-1.985-5.067-3.422c-1.437-1.437-2.578-3.126-3.422-5.067s-1.267-4.022-1.267-6.244c0-2.222 0.422-4.304 1.267-6.244s1.985-3.63 3.422-5.067c1.437-1.437 3.126-2.578 5.067-3.422s4.022-1.267 6.244-1.267c2.222 0 4.304 0.422 6.244 1.267s3.63 1.985 5.067 3.422c1.437 1.437 2.578 3.126 3.422 5.067s1.267 4.022 1.267 6.244c0 2.222-0.422 4.304-1.267 6.244s-1.985 3.63-3.422 5.067c-1.437 1.437-3.126 2.578-5.067 3.422s-4.022 1.267-6.244 1.267zM16 28.444c3.437 0 6.37-1.215 8.8-3.644s3.644-5.363 3.644-8.8c0-3.437-1.215-6.37-3.644-8.8s-5.363-3.644-8.8-3.644h-0.533c-0.178 0-0.356 0.030-0.533 0.089-0.178 0.178-0.296 0.37-0.356 0.578s-0.089 0.43-0.089 0.667c0 0.622 0.215 1.148 0.644 1.578s0.956 0.644 1.578 0.644c0.267 0 0.511-0.044 0.733-0.133s0.452-0.133 0.689-0.133c0.356 0 0.652 0.133 0.889 0.4s0.356 0.578 0.356 0.933c0 0.681-0.319 1.119-0.956 1.311s-1.207 0.289-1.711 0.289c-1.333 0-2.481-0.481-3.444-1.444s-1.444-2.111-1.444-3.444v-0.267c0-0.089 0.015-0.207 0.044-0.356-2.459 0.889-4.459 2.385-6 4.489s-2.311 4.519-2.311 7.244c0 3.437 1.215 6.37 3.644 8.8s5.363 3.644 8.8 3.644z"
      />
    </svg>
  );
}

export function HelpOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-HelpOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M16 26c0.556 0 1.028-0.194 1.417-0.583s0.583-0.861 0.583-1.417-0.194-1.028-0.583-1.417c-0.389-0.389-0.861-0.583-1.417-0.583s-1.028 0.194-1.417 0.583c-0.389 0.389-0.583 0.861-0.583 1.417s0.194 1.028 0.583 1.417c0.389 0.389 0.861 0.583 1.417 0.583zM14.5 19.625h3.042c0-1.028 0.090-1.757 0.271-2.187s0.618-0.979 1.313-1.646c0.972-0.944 1.646-1.75 2.021-2.417s0.563-1.403 0.563-2.208c0-1.528-0.521-2.771-1.563-3.729s-2.368-1.438-3.979-1.438c-1.417 0-2.646 0.375-3.687 1.125s-1.771 1.764-2.188 3.042l2.708 1.125c0.25-0.778 0.646-1.382 1.188-1.813s1.174-0.646 1.896-0.646c0.778 0 1.417 0.222 1.917 0.667s0.75 1.028 0.75 1.75c0 0.639-0.215 1.208-0.646 1.708s-0.91 0.986-1.438 1.458c-0.972 0.889-1.576 1.618-1.812 2.188s-0.354 1.576-0.354 3.021zM16 32c-2.194 0-4.264-0.417-6.208-1.25s-3.646-1.979-5.104-3.438c-1.458-1.458-2.604-3.16-3.438-5.104s-1.25-4.014-1.25-6.208c0-2.222 0.417-4.299 1.25-6.229s1.979-3.625 3.438-5.083c1.458-1.458 3.16-2.604 5.104-3.438s4.014-1.25 6.208-1.25c2.222 0 4.299 0.417 6.229 1.25s3.625 1.979 5.083 3.438c1.458 1.458 2.604 3.153 3.438 5.083s1.25 4.007 1.25 6.229c0 2.194-0.417 4.264-1.25 6.208s-1.979 3.646-3.438 5.104c-1.458 1.458-3.153 2.604-5.083 3.438s-4.007 1.25-6.229 1.25zM16 29c3.611 0 6.681-1.264 9.208-3.792s3.792-5.597 3.792-9.208c0-3.611-1.264-6.681-3.792-9.208s-5.597-3.792-9.208-3.792c-3.611 0-6.681 1.264-9.208 3.792s-3.792 5.597-3.792 9.208c0 3.611 1.264 6.681 3.792 9.208s5.597 3.792 9.208 3.792z"
      />
    </svg>
  );
}

export function InfoOutline({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-info-outline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      onClick={onClick}
    >
      <path
        fill={fill}
        d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm0 29.091C8.873 29.091 2.909 23.127 2.909 16S8.873 2.909 16 2.909 29.091 8.873 29.091 16 23.127 29.091 16 29.091zM14.545 14.545h2.909v10.182h-2.909V14.545zm0-6.182h2.909v2.909h-2.909V8.364z"
      />
    </svg>
  );
}

export function EventsOutline({
  fill = '#656565',
  size = 20,
  onClick,
  style,
}: IconProps & { style?: React.CSSProperties }) {
  return (
    <svg
      id="icon-EventsOutline"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={style}
    >
      <path
        fill={fill}
        d="M20 25.6c-1.12 0-2.067-0.387-2.84-1.16s-1.16-1.72-1.16-2.84 0.387-2.067 1.16-2.84c0.773-0.773 1.72-1.16 2.84-1.16s2.067 0.387 2.84 1.16c0.773 0.773 1.16 1.72 1.16 2.84s-0.387 2.067-1.16 2.84c-0.773 0.773-1.72 1.16-2.84 1.16zM4.8 32c-0.88 0-1.633-0.313-2.26-0.94s-0.94-1.38-0.94-2.26v-22.4c0-0.88 0.313-1.633 0.94-2.26s1.38-0.94 2.26-0.94h1.6v-3.2h3.2v3.2h12.8v-3.2h3.2v3.2h1.6c0.88 0 1.633 0.313 2.26 0.94s0.94 1.38 0.94 2.26v22.4c0 0.88-0.313 1.633-0.94 2.26s-1.38 0.94-2.26 0.94h-22.4zM4.8 28.8h22.4v-16h-22.4v16zM4.8 9.6h22.4v-3.2h-22.4v3.2z"
      />
    </svg>
  );
}

export function EventsFilled({
  fill = '#656565',
  size = 20,
  onClick,
  style,
}: IconProps & { style?: React.CSSProperties }) {
  return (
    <svg
      id="icon-EventsFilled"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={style}
    >
      <path
        fill={fill}
        d="M9.572 0v3.204h12.857v-3.204h3.163v3.204h1.622c0.876 0 1.624 0.312 2.248 0.936s0.936 1.372 0.936 2.248v22.428c0 0.876-0.312 1.624-0.936 2.248s-1.372 0.936-2.248 0.936h-22.428c-0.876 0-1.624-0.312-2.248-0.936s-0.936-1.372-0.936-2.248v-22.428c0-0.876 0.312-1.624 0.936-2.248s1.372-0.936 2.248-0.936h1.622v-3.204h3.163zM4.765 28.837h22.469v-16.061h-22.469v16.061zM20.005 17.622c1.116 0 2.060 0.384 2.83 1.155s1.155 1.714 1.155 2.83c0 1.116-0.384 2.060-1.155 2.83s-1.714 1.155-2.83 1.155c-1.116 0-2.060-0.384-2.83-1.155s-1.155-1.714-1.155-2.83 0.384-2.060 1.155-2.83c0.77-0.77 1.714-1.155 2.83-1.155z"
      />
    </svg>
  );
}

export function DocumentIcon({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-document"
      width={size}
      height={size}
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M4.5 16.5H12.5V14.5H4.5V16.5ZM4.5 12.5H12.5V10.5H4.5V12.5ZM2.5 20.5C1.95 20.5 1.47917 20.3042 1.0875 19.9125C0.695833 19.5208 0.5 19.05 0.5 18.5V2.5C0.5 1.95 0.695833 1.47917 1.0875 1.0875C1.47917 0.695833 1.95 0.5 2.5 0.5H10.5L16.5 6.5V18.5C16.5 19.05 16.3042 19.5208 15.9125 19.9125C15.5208 20.3042 15.05 20.5 14.5 20.5H2.5ZM9.5 7.5V2.5H2.5V18.5H14.5V7.5H9.5Z"
        fill={fill}
      />
    </svg>
  );
}

export function SvgDocumentIcon({
  fill = '#656565',
  size = 20,
  onClick,
}: IconProps) {
  return (
    <svg
      id="icon-svg-document"
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M8 18.5C7.45 18.5 6.97917 18.3042 6.5875 17.9125C6.19583 17.5208 6 17.05 6 16.5V4.5C6 3.95 6.19583 3.47917 6.5875 3.0875C6.97917 2.69583 7.45 2.5 8 2.5H20C20.55 2.5 21.0208 2.69583 21.4125 3.0875C21.8042 3.47917 22 3.95 22 4.5V16.5C22 17.05 21.8042 17.5208 21.4125 17.9125C21.0208 18.3042 20.55 18.5 20 18.5H8ZM8 16.5H20V4.5H8V16.5ZM4 22.5C3.45 22.5 2.97917 22.3042 2.5875 21.9125C2.19583 21.5208 2 21.05 2 20.5V6.5H4V20.5H18V22.5H4Z"
        fill={fill}
      />
      <path
        d="M17.97 13.5542C17.4687 13.5542 17.1109 13.4665 16.8967 13.291C16.6848 13.1133 16.572 12.8182 16.5583 12.4058C16.547 12.1528 16.539 11.8669 16.5344 11.5479C16.5321 11.2288 16.5321 10.9121 16.5344 10.5977C16.539 10.2809 16.547 9.99951 16.5583 9.75342C16.572 9.32048 16.686 9.014 16.9001 8.83398C17.1166 8.65169 17.4721 8.56055 17.9666 8.56055C18.4382 8.56055 18.7823 8.64941 18.9988 8.82715C19.2153 9.00488 19.3349 9.29769 19.3577 9.70557C19.3691 9.81038 19.3736 9.93001 19.3713 10.0645C19.3713 10.1966 19.3668 10.3162 19.3577 10.4233H18.5579C18.567 10.3003 18.5715 10.1556 18.5715 9.98926C18.5738 9.82064 18.5693 9.6748 18.5579 9.55176C18.5396 9.33757 18.3425 9.23047 17.9666 9.23047C17.5723 9.23047 17.3695 9.33757 17.3582 9.55176C17.3422 9.8571 17.3319 10.1841 17.3274 10.5327C17.3228 10.8813 17.3228 11.23 17.3274 11.5786C17.3342 11.9272 17.3445 12.2542 17.3582 12.5596C17.3627 12.6644 17.414 12.7453 17.512 12.8022C17.6099 12.8569 17.7626 12.8843 17.97 12.8843C18.3733 12.8843 18.5875 12.776 18.6125 12.5596C18.6171 12.4707 18.6194 12.359 18.6194 12.2246C18.6194 12.0879 18.6171 11.9762 18.6125 11.8896H18.0007V11.1753H19.3953C19.4044 11.3553 19.4089 11.5547 19.4089 11.7734C19.4089 11.9922 19.4021 12.203 19.3884 12.4058C19.3725 12.8182 19.254 13.1133 19.033 13.291C18.8119 13.4665 18.4576 13.5542 17.97 13.5542Z"
        fill={fill}
      />
      <path
        d="M15.1958 13.3809H13.8081L13.0015 8.5H13.8389L14.2456 10.9951L14.3823 12.6562H14.6147L14.7515 10.9951L15.165 8.5H15.999L15.1958 13.3809Z"
        fill={fill}
      />
      <path
        d="M10.6064 13.5542C10.1051 13.5542 9.74626 13.4665 9.52979 13.291C9.31331 13.1133 9.19596 12.8182 9.17773 12.4058C9.15951 12.1688 9.1652 11.9261 9.19482 11.6777H9.96045C9.94678 11.835 9.9388 11.9888 9.93652 12.1392C9.93652 12.2896 9.9445 12.4297 9.96045 12.5596C9.97184 12.6644 10.0265 12.7453 10.1245 12.8022C10.2248 12.8569 10.3843 12.8843 10.603 12.8843C10.8195 12.8843 10.9744 12.8569 11.0679 12.8022C11.1636 12.7453 11.2183 12.6644 11.2319 12.5596C11.2479 12.4411 11.2547 12.3294 11.2524 12.2246C11.2502 12.1175 11.2433 12.0047 11.2319 11.8862C11.2205 11.7882 11.1841 11.7017 11.1226 11.6265C11.061 11.5513 10.9391 11.5011 10.7568 11.4761L10.1895 11.3564C9.92057 11.304 9.71322 11.2288 9.56738 11.1309C9.42383 11.0329 9.32243 10.9098 9.26318 10.7617C9.20394 10.6136 9.16976 10.4393 9.16064 10.2388C9.15609 10.1431 9.15381 10.0519 9.15381 9.96533C9.15609 9.87874 9.15951 9.79215 9.16406 9.70557C9.17773 9.29769 9.29281 9.00488 9.50928 8.82715C9.72575 8.64941 10.0903 8.56055 10.603 8.56055C11.0861 8.56055 11.4359 8.64941 11.6523 8.82715C11.8688 9.00488 11.985 9.29769 12.001 9.70557C12.0078 9.79671 12.009 9.90951 12.0044 10.0439C12.0021 10.1761 11.9976 10.3026 11.9907 10.4233H11.2183C11.2388 10.1248 11.241 9.83431 11.2251 9.55176C11.2069 9.33757 10.9984 9.23047 10.5996 9.23047C10.3831 9.23047 10.2271 9.25781 10.1313 9.3125C10.0356 9.36719 9.98096 9.44694 9.96729 9.55176C9.95133 9.66569 9.94336 9.78076 9.94336 9.89697C9.94564 10.0109 9.95361 10.1248 9.96729 10.2388C9.97868 10.339 10.0151 10.4256 10.0767 10.4985C10.1382 10.5692 10.2658 10.617 10.4595 10.6421L10.9824 10.7412C11.2604 10.7913 11.4735 10.8677 11.6216 10.9702C11.7697 11.0728 11.8734 11.2004 11.9326 11.353C11.9941 11.5034 12.0295 11.6812 12.0386 11.8862C12.0454 11.9774 12.0477 12.0651 12.0454 12.1494C12.0431 12.2337 12.0386 12.3192 12.0317 12.4058C12.0135 12.8182 11.895 13.1133 11.6763 13.291C11.4598 13.4665 11.1032 13.5542 10.6064 13.5542Z"
        fill={fill}
      />
    </svg>
  );
}

export function AIIcon({ fill, size = 98, onClick }: IconProps) {
  return (
    <svg
      id="icon-ai"
      width={size}
      height={size}
      viewBox="0 0 98 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M24.5672 2.39453C23.423 3.06523 23.2652 4.01211 23.2652 10.1668V16.0059H21.2137C19.5566 16.0059 19.0043 16.1242 18.2547 16.6371C16.5977 17.7812 16.1637 18.6098 16.0453 21.0559L15.9664 23.2652H10.0879C2.31562 23.2652 2.07891 23.3836 2.07891 27.4473C2.07891 29.5777 2.11836 29.775 2.86797 30.5246L3.65703 31.3137H9.81172H15.9664V34.3516V37.4289L9.65391 37.5078L3.34141 37.5867L2.6707 38.3758C2.07891 39.0859 2 39.441 2 41.532C2 43.7809 2.03945 43.9387 2.78906 44.7277L3.57812 45.5168H9.73281H15.8875V48.5941V51.6715H9.85117H3.69648L2.90742 52.4605C2.11836 53.2496 2.11836 53.4074 2.11836 55.6562C2.11836 57.7473 2.19727 58.1023 2.78906 58.8125L3.45977 59.6016L9.77227 59.6805L16.0848 59.7594V62.8367V65.8746H9.85117H3.69648L2.90742 66.6637C2.15781 67.4527 2.11836 67.6105 2.11836 69.741C2.11836 73.8047 2.35508 73.923 10.2062 73.923H16.0453V75.9746C16.0453 77.6316 16.1637 78.184 16.6766 78.9336C17.7813 80.5906 18.6098 81.0246 21.0953 81.143L23.3047 81.2219V87.0609C23.3047 94.8727 23.4625 95.0699 27.6445 95.0699C29.5777 95.0699 29.8145 95.0305 30.5641 94.2809L31.3531 93.4918V87.3371V81.1824H34.391H37.4684L37.5473 87.4949L37.6262 93.8074L38.4152 94.4781C39.1254 95.0699 39.4805 95.1488 41.5715 95.1488C43.8203 95.1488 43.9781 95.1094 44.7672 94.3598L45.5562 93.5707V87.416V81.2613H48.6336H51.7109V87.416V93.5707L52.5 94.3598C53.2891 95.1488 53.4469 95.1488 55.6957 95.1488C57.7867 95.1488 58.1418 95.0699 58.8519 94.4781L59.641 93.8074L59.7199 87.4949L59.7988 81.1824H62.8762H65.9141V87.3371V93.4918L66.7031 94.2809C67.4527 95.0305 67.6894 95.0699 69.6227 95.0699C73.8441 95.0699 73.9625 94.8332 73.9625 87.0609V81.2219L76.1719 81.143C78.5391 81.0246 79.3676 80.6301 80.5117 79.0914C80.9457 78.4996 81.143 77.7895 81.2219 76.093L81.3008 73.8836H87.1398C94.9516 73.8836 95.1488 73.7258 95.1488 69.5437C95.1488 67.6105 95.1094 67.3738 94.3598 66.6242L93.5707 65.8352H87.416H81.2613V62.7973V59.7199L87.5738 59.641L93.8863 59.5621L94.557 58.773C95.1488 58.0629 95.2277 57.7078 95.2277 55.6168C95.2277 53.368 95.1883 53.2102 94.4387 52.4211L93.6496 51.632H87.4949H81.3402V48.6336V45.5562H87.4949H93.6496L94.4387 44.7672C95.2277 43.9781 95.2277 43.8203 95.2277 41.5715C95.2277 39.4805 95.1488 39.1254 94.557 38.4152L93.8863 37.6262L87.5738 37.5473L81.2613 37.4684V34.391V31.3531H87.416H93.5707L94.3598 30.5641C95.1094 29.775 95.1488 29.6172 95.1488 27.4867C95.1488 23.423 94.9121 23.3047 87.0609 23.3047H81.2219V21.2531C81.2219 19.5961 81.1035 19.0437 80.5906 18.2547C79.4859 16.5977 78.3418 16.0453 76.0535 16.0453H74.002V10.1668C74.002 2.31563 73.8836 2.07891 69.8199 2.07891C67.6894 2.07891 67.4922 2.11836 66.7426 2.86797L65.9535 3.65703V9.81172V15.9664H62.9156H59.8383L59.7594 9.65391L59.6805 3.34141L58.8914 2.6707C58.1812 2.07891 57.8262 2 55.7352 2C53.4863 2 53.3285 2.03945 52.5394 2.78906L51.7504 3.57812V9.73281V15.8875H48.6336H45.5562V9.85117V3.69648L44.7672 2.90742C43.9781 2.11836 43.8203 2.11836 41.5715 2.11836C39.4805 2.11836 39.1254 2.19727 38.4152 2.78906L37.6262 3.45977L37.5473 9.77227L37.4684 16.0848H34.391H31.3531V9.85117V3.69648L30.5641 2.90742C29.775 2.15781 29.6172 2.11836 27.4078 2.11836C26.1059 2.07891 24.8434 2.23672 24.5672 2.39453ZM46.6215 34.3516C46.7793 34.7855 48.9492 40.7035 51.4348 47.5289C53.9598 54.3543 56.0508 60.1539 56.1297 60.3906C56.248 60.8641 55.893 60.9035 51.9082 60.9035H47.5684L46.9766 58.9703L46.3453 56.9977L42.0055 57.0766L37.6656 57.1555L37.0344 58.9703L36.4031 60.7852L32.1422 60.8641C28.1574 60.9035 27.9207 60.9035 28.118 60.4301C28.2758 59.9961 37.5078 34.9039 37.8629 33.9176C37.9418 33.6809 39.0465 33.6019 42.1633 33.6019H46.3059L46.6215 34.3516ZM66.427 47.1738L66.348 60.7852H62.166H57.984L57.9051 47.1738L57.8656 33.6019H62.2055H66.5453L66.427 47.1738Z"
        fill={fill || '#D9E7FF'}
        stroke={fill || 'url(#paint0_linear_ai_icon)'}
        strokeWidth="4"
      />
      <path
        d="M40.9009 46.7794C40.2696 48.831 39.7173 50.6458 39.7173 50.8036C39.7173 51.0403 40.5063 51.1192 42.2423 51.1192C44.1755 51.1192 44.7673 51.0403 44.6489 50.7642C44.6095 50.6063 44.0571 48.752 43.4653 46.7399C42.8341 44.7278 42.2817 43.0708 42.2028 43.0708C42.1239 43.0708 41.5321 44.7278 40.9009 46.7794Z"
        fill={fill || '#7F7CED'}
      />
      <defs>
        <linearGradient
          id="paint0_linear_ai_icon"
          x1="48.6139"
          y1="2"
          x2="48.6139"
          y2="95.1488"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.100962" stopColor="#C39DF8" />
          <stop offset="1" stopColor="#455FE4" />
        </linearGradient>
      </defs>
    </svg>
  );
}
